import { render } from "./CartNotification.vue?vue&type=template&id=e149e1d2&scoped=true"
import script from "./CartNotification.vue?vue&type=script&lang=js"
export * from "./CartNotification.vue?vue&type=script&lang=js"

import "./CartNotification.vue?vue&type=style&index=0&id=e149e1d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e149e1d2"]])

export default __exports__